module.exports = __webpack_public_path__ + "img/dispatch-center.c694606b.svg";